"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridScaleStates = void 0;
const consts_1 = __importDefault(require("./consts"));
// eslint-disable-next-line import/prefer-default-export
exports.gridScaleStates = [
    {
        maxDistance: 10,
        cellSize: consts_1.default.DEFAULT_GRID_CELL_SIZE,
        divisionsPerCell: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL,
        cellSizeSI: consts_1.default.DEFAULT_GRID_CELL_SIZE_SI,
        divisionsPerCellSI: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL_SI,
    },
    {
        maxDistance: 20,
        cellSize: consts_1.default.DEFAULT_GRID_CELL_SIZE,
        divisionsPerCell: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL / 2,
        cellSizeSI: consts_1.default.DEFAULT_GRID_CELL_SIZE_SI,
        divisionsPerCellSI: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL_SI / 2,
    },
    {
        maxDistance: 35,
        cellSize: consts_1.default.DEFAULT_GRID_CELL_SIZE,
        divisionsPerCell: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL / 4,
        cellSizeSI: consts_1.default.DEFAULT_GRID_CELL_SIZE_SI,
        divisionsPerCellSI: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL_SI / 4,
    },
    {
        maxDistance: 55,
        cellSize: consts_1.default.DEFAULT_GRID_CELL_SIZE * 2,
        divisionsPerCell: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL / 4,
        cellSizeSI: consts_1.default.DEFAULT_GRID_CELL_SIZE_SI * 2,
        divisionsPerCellSI: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL_SI / 4,
    },
    {
        maxDistance: 100,
        cellSize: consts_1.default.DEFAULT_GRID_CELL_SIZE * 4,
        divisionsPerCell: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL / 2,
        cellSizeSI: consts_1.default.DEFAULT_GRID_CELL_SIZE_SI * 4,
        divisionsPerCellSI: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL_SI / 2,
    },
    {
        maxDistance: Infinity,
        cellSize: consts_1.default.DEFAULT_GRID_CELL_SIZE * 8,
        divisionsPerCell: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL,
        cellSizeSI: consts_1.default.DEFAULT_GRID_CELL_SIZE_SI * 8,
        divisionsPerCellSI: consts_1.default.DEFAULT_GRID_DIVISIONS_PER_CELL_SI,
    },
];
